<!--
 * @Author: 张家林
 * @LastEditors: 张家林
-->
<template>
  <div id="app">
    <div>
      <!-- <wx-open-launch-weapp userName="gh_e29df2b1d9ab">
        <script type="text/wxtag-template">
          <h1>跳转小程序</h1>
        </script>
      </wx-open-launch-weapp> -->
    </div>
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
// import Wx from 'weixin-js-sdk'
const axiosIns = axios.create()
export default {
  name: 'app',
  created () {
    // this.getWxConfig()
    const oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js'
    oScript.onload = this.getWxConfig
    document.body.appendChild(oScript)
  },
  methods: {
    async getWxConfig () {
      window.wx.ready(function (res) {
        console.log('config成功', res)
      })
      window.wx.error(function (eror) {
        console.log('config失败', eror)
      })
      let url = window.location.href.split('#')[0]
      const res = await axiosIns.post('https://www.jrerdangjia.com/jr/v2/wechatconfig/jssdk', {
        url
      })
      if (res.data.success) {
        window.wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.nonceStr,
          signature: res.data.data.signature,
          jsApiList:['chooseImage', 'previewImage'],
          openTagList: [
            'wx-open-launch-weapp'
          ]
        })

      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
